<template>
  <div class="v-brand pt--4">
    <div class="container v-brand__content">
      <h2 class="mt--5 text--center">
        Serdecznie witamy w Twoim systemie planowania wizyt serwisowych.<br />Wybierz
        markę:
      </h2>
      <div>
        <a class="select-brandItem" href="https://serwis.inchcape.pl/"
          ><img src="@/assets/logo.png" alt="BMW"
        /></a>

        <a
          class="select-brandItem"
          href="https://jlr.serwis.inchcape.pl/?brand_id=56"
          ><img src="@/assets/jaguar-logo.png" alt="jaguar"
        /></a>

        <a
          class="select-brandItem"
          href="https://jlr.serwis.inchcape.pl/?brand_id=46"
          ><img src="@/assets/land-rover.png" alt="landorver"
        /></a>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";

import { mapGetters, mapActions } from "vuex";
import lead from "../mixins/lead.js";

export default {
  name: "home",
  mixins: [lead],
  components: {
    Footer,
    Header,
  },
  computed: {
    ...mapGetters({
      getBrands: "definitions/getBrands",
      getDealers: "definitions/getDealers",
    }),
  },
  methods: {
    ...mapActions({
      fetchDealers: "definitions/fetchDealers",
    }),
  },
  mounted() {
    if (this.$route.query) {
      this.lead = { ...this.lead, ...this.$route.query };
      if (this.$route.query.dealer_id) {
        this.fetchDealers();
      }
    }
  },
};
</script>
<style lang="scss">
.v-brand {
  &__content {
    min-height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__logo {
    max-width: 100px;
    height: auto;
  }
  &__btn {
    min-width: 268px;
  }
  &__select {
    max-width: 400px;
  }
}
.select-brandItem {
  cursor: pointer;
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
  &.active {
    opacity: 1;
    border-bottom: 2px solid #ccc;
  }
  img {
    max-height: 90px;
    margin: 2rem;
  }
}
</style>
